export default __webpack_public_path__ + "static/media/watch.601f8423.svg";